import Vue from "vue";
import VeeValidate from "vee-validate";

import VueI18n from "vue-i18n";
import zh_TW from "vee-validate/dist/locale/zh_TW";
import { Validator } from "vee-validate";

Vue.use(VueI18n);
const i18n = new VueI18n({
	locale: "zh_TW"
});

Vue.use(VeeValidate, {
	i18n,
	i18nRootKey: "validation",
	events: 'input|blur',
	dictionary: {
		zh_TW
	}
});

VeeValidate.Validator.extend('idno', {
	getMessage: (field) => '請輸入正確的身份證',
	validate: (value) => {
		return /^[A-Z](1|2)[0-9]{8}$/.test(value);
	}
});

VeeValidate.Validator.extend('idnoSex', {
	getMessage: (field) => '請輸入正確的身分證或性別錯誤',
	validate: (id, [sex]) => {
		var id = id.trim();

		var verification = id.match("^[A-Z][12]\\d{8}$");
		if(!verification){
			return false;
		}

		if((id[1] == 1 && sex == 'F') || (id[1] == 2 && sex == 'M'))
		{
			return false;
		}

		var conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO";
		var weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];

		id = String(conver.indexOf(id[0]) + 10) + id.slice(1);

		var checkSum = 0;
		for (let i = 0; i < id.length; i++) {
			var c = parseInt(id[i]);
			var w = weights[i];
			checkSum += c * w;
		}

		return checkSum % 10 == 0;
	}
},{
	hasTarget: true
});

VeeValidate.Validator.extend('kinIdnoSex', {
	getMessage: (field) => '請輸入正確的身分證或性別錯誤',
	validate: (id, [kinship]) => {
		var id = id.trim();

    //身份證與新版居留證驗證
		var verification = id.match("^[A-Z][12]\\d{8}$");
    //舊版居留證驗證
    var oldcerification = id.match("^[A-Z][ABCD]\\d{8}$");
		if(!verification && !oldcerification){
			return false;
		}

		if((verification && id[1] == 1 && kinship == '2') || (verification && id[1] == 2 && kinship == '1') ||
      (verification && id[1] == 8 && kinship == '2') || (verification && id[1] == 9 && kinship == '1') ||
      (oldcerification && id[2] == 'A' && kinship == '2') || (oldcerification && id[2] == 'B' && kinship == '1') ||
      (oldcerification && id[2] == 'C' && kinship == '2') || (oldcerification && id[2] == 'D' && kinship == '1'))
		{
			return false;
		}

		var conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO";
		var weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];

		id = verification ?
      String(conver.indexOf(id[0]) + 10) + id.slice(1) :
      String(conver.indexOf(id[0]) + 10) +  String((conver.indexOf(id[1]) + 10)%10) + id.slice(2);

		var checkSum = 0;
		for (let i = 0; i < id.length; i++) {
			var c = parseInt(id[i]);
			var w = weights[i];
			checkSum += c * w;
		}

		return checkSum % 10 == 0;
	}
},{
	hasTarget: true
});

VeeValidate.Validator.extend('phone', {
	getMessage: (field) => '請輸入正確的號碼',
	validate: (value) => {
		return /^[0-9]{9,10}$/.test(value);
	}
});

VeeValidate.Validator.extend('tel', {
	getMessage: (field) => '請輸入正確的號碼',
	validate: (value) => {
		return /^[0-9]{9,10}$/.test(value);
	}
});



const Dictionary = {
	zh_TW: {
		messages: {
			required: "必填選項",
			email: "必須是有效的電子郵件地址",
			min: (field, args) => `長度需超過${args[0]}字元！`,
			max: (field, args) => `長度不能超過${args[0]}字元！`
		},
	}
};

Validator.localize(Dictionary);
